const cache = new Map();

export const fetchCachedOnce = (key, fetcher) => {
  if (!cache.has(key)) {
    const promise = fetcher().catch((err) => {
      cache.delete(key);
      throw err;
    });
    cache.set(key, promise);
  }
  return cache.get(key);
};
